import Modal from '../../shared/components/Modal';
import { ReactComponent as OnepromathLogo } from '../../resources/images/logo2.svg';

const OnepromathApplicationResultModal = ({ showApplicationResultModal, closeApplicationResultModal, message }) => {
  return (
    <Modal show={showApplicationResultModal} closeModal={closeApplicationResultModal}>
      <div className={'max-w-[300px]'}>
        <div className={'flex justify-center'}>
          <OnepromathLogo className="w-[72px]"/>
        </div>
        <div className={'font-[nanum-square-b] mt-[20px]'}>
          {message}
        </div>
      </div>
    </Modal>
  );
};

export default OnepromathApplicationResultModal;